import {gql} from '@apollo/client'

export const accountUpdateMutation = gql`
  mutation AccountUpdate($firstName: String!, $lastName: String!) {
    accountUpdate(
      input: {
        firstName: $firstName,
        lastName: $lastName
      }
    ) {
      accountErrors {
        field
        code
      }
      user {
        firstName
        lastName
      }
    }
  }
`
